import HtmlToPdfInterfaceClass from "../../infrastructure/html-to-pdf-interface.js";
import AppError from "../../domain/errors/app-error";

export default class {
	constructor() {
		this.interface = new HtmlToPdfInterfaceClass();
	}

	async get_pdf_from_html(html_content, file_name) {
		try {
			return await this.interface.get_pdf_from_html(html_content, file_name);
		} catch (e) {
			throw new AppError("error_get_pdf_from_html", null, e);
		}
	}
}
